module.exports = __webpack_public_path__ + "img/idel1.b1662d8c.png";